var map = {
	"./standard01.PNG": 398,
	"./standard02.PNG": 125,
	"./standard03.PNG": 844,
	"./standard04.PNG": 915,
	"./standard05.PNG": 370,
	"./standard06.PNG": 337,
	"./standard07.PNG": 664,
	"./standard08.PNG": 999,
	"./standard09.PNG": 569,
	"./standard10.PNG": 180,
	"./standard11.PNG": 877,
	"./standard12.PNG": 630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 755;